var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var ProjectComponent = /** @class */ (function (_super) {
    __extends(ProjectComponent, _super);
    function ProjectComponent(injector, translateService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.translateService = translateService;
        _this.reasons = [];
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        return _this;
    }
    ProjectComponent.prototype.ngOnInit = function () {
        this.meta.addTags([
            { name: 'robots', content: 'noindex' }
        ]);
        this.setTitle('Despre proiect');
    };
    return ProjectComponent;
}(SeoAwareBaseComponent));
export { ProjectComponent };



// WEBPACK FOOTER //
// ./src/app/about-us/project.component.ts.pre-build-optimizer.js